import {
  Select,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { COVERAGE_CODE } from "@/constants";

import useUserInfo from "@/hooks/use-user-info";
import { getPlanCoverageTypeName } from "@/lib/plan-coverage-utils";

import {
  setActiveCoverage,
  setSelectedCoverageYear,
} from "@/store/active-coverage-slice";
import type { RootState } from "@/store/store";
import { useDispatch, useSelector } from "react-redux";
import { cn, isCoverageActiveOrExtended } from "@/lib/utils";

const PlanCoverageSelector = () => {
  const userInfo = useUserInfo();

  const dispatch = useDispatch();
  const { activeCoverage, coveragePlanDates } = useSelector(
    (state: RootState) => state.planCoverageInfo,
  );

  const handleValueChange = (value: string) => {
    const coverage = userInfo?.planCoverageInfo.find((coverage) => {
      return coverage?.claimCoverageCode === value;
    });
    if (coverage) {
      dispatch(setActiveCoverage(coverage));

      const selectedCoveragePlanDate = coveragePlanDates.find(
        (coverageDate) => coverageDate.type === coverage.claimCoverageCode,
      )?.periods[0];
      dispatch(setSelectedCoverageYear(selectedCoveragePlanDate ?? null));
    }
  };

  // console.log("arr$$", userInfo.planCoverageInfo)

  const selectableCoverages = userInfo.planCoverageInfo
    .filter(isCoverageActiveOrExtended)
    .filter((c) => c.claimCoverageCode !== COVERAGE_CODE.ORTHODONTIA);

  if (!activeCoverage || Object.keys(activeCoverage).length < 1) return null;

  const isSingleCoverage = selectableCoverages.length <= 1;

  return (
    <div
      className="flex flex-row items-center justify-center space-x-2"
      data-hj-suppress
    >
      <Select
        value={getPlanCoverageTypeName(
          activeCoverage?.claimCoverageCode as COVERAGE_CODE,
        )}
        onValueChange={handleValueChange}
      >
        <SelectTrigger
          className={cn(
            "min-w-[180px] sm:min-w-[200px]",
            isSingleCoverage && "pointer-events-none [&>svg]:hidden",
          )}
        >
          <SelectValue placeholder="Select Plan Coverage Type ">
            {getPlanCoverageTypeName(
              activeCoverage?.claimCoverageCode as COVERAGE_CODE,
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {userInfo.planCoverageInfo.filter(isCoverageActiveOrExtended).map(
            (coverage, index) =>
              coverage.claimCoverageCode !== COVERAGE_CODE.ORTHODONTIA && (
                <SelectItem
                  key={coverage.insCoverageTypeDesc + index}
                  value={coverage.claimCoverageCode}
                  className="cursor-pointer"
                >
                  {getPlanCoverageTypeName(
                    coverage.claimCoverageCode as COVERAGE_CODE,
                  )}
                </SelectItem>
              ),
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PlanCoverageSelector;
